import {FC, PropsWithChildren} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';

import {useNetworkStatus} from '@/contexts/network-status-context';
import ApplicationHeader from '../application-header';
import ContainerCard from '../container-card';
import {GenericError} from './generic-error';

export const ErrorFallback: FC<PropsWithChildren> = ({children}) => {
  const {isOffline} = useNetworkStatus();

  return (
    <>
      <ApplicationHeader />

      <div className={twMerge(clsx('relative flex grow', isOffline && 'opacity-20'))}>
        <div className="flex grow flex-row gap-4">
          <ContainerCard className="flex size-full flex-col">
            <ContainerCard.Content className="mt-0 grow pt-6">{children ?? <GenericError />}</ContainerCard.Content>
          </ContainerCard>
        </div>
      </div>
    </>
  );
};
